import Slider from "react-slick";
import { BiCircle, BiSolidCircle } from "react-icons/bi";
import { useState } from "react";
import { FaStar } from "react-icons/fa6";

function Testimonial({ name, quote, job, imageUrl }: TestimonialProps) {
  return (
    <div className="h-[500px] flex flex-col md:flex-row justify-evenly md:justify-between items-center rounded-3xl backdrop-blur-lg">
      <div className="bg-background md:rounded-l-3xl md:rounded-tr-none rounded-t-3xl  h-60 md:h-full w-full md:w-[30%] flex flex-col items-center justify-center ">
        <img
          className="object-cover w-20 h-20  md:w-40 md:h-40 rounded-full shadow-2xl"
          src={
            imageUrl ??
            "https://uxwing.com/wp-content/themes/uxwing/download/peoples-avatars/default-avatar-profile-picture-female-icon.png"
          }
          alt="Me"
        />
        <div className={"p-1 pt-5 text-center text-primary"}>
          <h1 className="text-xl md:text-2xl font-bold ">{name}</h1>
          <p className="">{job}</p>
        </div>
      </div>
      <div className="flex flex-col text-primary bg-surface bg-opacity-80 rounded-b-3xl md:rounded-bl-none md:rounded-r-3xl h-full content-center items-center  min-w-[70%] justify-center  ">
        <p className="italic max-w-md md:text-xl p-5 text-center">"{quote}"</p>
        <div className="flex flex-row pt-10 items-center justify-center">
          <FaStar size={25} color={"yellow"} className="m-1" />
          <FaStar size={25} color={"yellow"} className="m-1" />
          <FaStar size={25} color={"yellow"} className="m-1" />
          <FaStar size={25} color={"yellow"} className="m-1" />
          <FaStar size={25} color={"yellow"} className="m-1" />
        </div>
      </div>
    </div>
  );
}

interface TestimonialProps {
  name: string;
  quote: string;
  job: string;
  imageUrl?: string;
  rating: number;
}

export default function Testimonials() {
  const testimonials: TestimonialProps[] = [
    {
      name: "Karel",
      quote:
        "As one of the first beta users, I can assure you these developers listen to what you want.",
      job: "Amateur Musician",
      rating: 5,
    },
    {
      name: "Claire",
      quote:
        "The melodic dictation exercises significantly increased my ability to play along with any song I hear",
      job: "Professional Musician",
      rating: 5,
    },
    {
      name: "Daan",
      quote:
        "I see a lot of potential in this trainer, I'm already a huge fan of the rhythm exercises, can't wait to see where this goes",
      job: "Music & Technology Teacher",
      rating: 4,
    },
  ];

  const [page, setPage] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (current: any, next: any) => setPage(next),
    customPaging: (i: any) => {
      if (i === page) {
        return <BiSolidCircle color={"#171717"} className="mt-5" />;
      } else {
        return <BiCircle color={"#171717"} className="mt-5" />;
      }
    },
  };
  return (
    <div
      id="testimonials"
      className="bg-primary py-10 pb-16 flex flex-col content-center justify-center items-center max-w-full"
    >
      <h1 className="md:text-8xl text-6xl mt-10  text-on_primary">
        Testimonials
      </h1>
      <p className="md:text-2xl text-center text-xl mt-5 mb-16 text-on_primary">
        Learn what others have to say about PlayGuru.
      </p>
      <Slider
        {...settings}
        className={"rounded-3xl max-w-[90%] lg:max-w-[1000px] "}
      >
        {testimonials.map((t) => (
          <Testimonial {...t} />
        ))}
      </Slider>
    </div>
  );
}
